export default __webpack_public_path__ + "static/logo-white-f83364298a5847586a271638732dc1a1.png";